import tw from 'tailwind-styled-components'

export const CreateSrModalParagraph = tw.p`text-center`
export const CreateSrModalFields = tw.div`flex flex-col gap-4`
